export default __webpack_public_path__ + "static/media/lottery-banners-ms.2a3b869c.webp";